var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedal1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C16.4183 24 20 20.4183 20 16C20 11.5817 16.4183 8 12 8C7.58172 8 4 11.5817 4 16C4 20.4183 7.58172 24 12 24ZM12 21C14.7614 21 17 18.7614 17 16C17 13.2386 14.7614 11 12 11C9.23858 11 7 13.2386 7 16C7 18.7614 9.23858 21 12 21Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16C15 17.6569 13.6569 19 12 19C10.3431 19 9 17.6569 9 16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5837 7.11C16.8351 7.23989 17.1486 7.15277 17.2828 6.90363L20.2064 1.4741C20.5651 0.807868 20.0826 0 19.3259 0H15.5937C15.2278 0 14.8911 0.199887 14.7158 0.521148L13.2698 3.17224C13.1884 3.32148 13.1884 3.50185 13.2698 3.65109L14.6615 6.20261C14.7256 6.32007 14.8343 6.40636 14.9621 6.44594C15.5256 6.62044 16.0677 6.84342 16.5837 7.11Z",
    fill: "#FCFCFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41654 7.11024C7.16501 7.23988 6.85152 7.15277 6.71737 6.90363L3.79378 1.4741C3.43504 0.807868 3.91757 0 4.67425 0H8.4064C8.77234 0 9.10906 0.199887 9.28429 0.521148L11.8588 5.24103C12.0434 5.57946 11.7912 5.99498 11.4064 6.01807C10.0186 6.10135 8.65344 6.47273 7.41654 7.11024Z",
    fill: "#FCFCFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal1);
export default __webpack_public_path__ + "static/media/medal-1.02a3c40f0478c83a720234f0c16bab14.svg";
export { ForwardRef as ReactComponent };